import { useTranslation } from "@pancakeswap/localization"
import { useToast } from "@pancakeswap/uikit"
import { ToastDescriptionWithTx } from "components/Toast"
import { useCallWithMarketGasPrice } from "hooks/useCallWithMarketGasPrice"
import { useBuyVoucher } from "hooks/useContract"
import { useCallback, useState } from "react"
import { useAppDispatch } from 'state'
import { fetchDataUser, fetchFillAmount, fetchFillEmail, fetchFillPhoneNumber } from 'state/giftCards/actions'
import { fetchPublicDataUser } from 'state/giftCards/fetchData'
import { fetchHistory } from "state/history/actions"
import { fetchHistoryData } from "state/history/fetchData"
import { PAGE_SIZE } from "config";
import moment from 'moment'

export const useBuyVouchers = (contractAddress, tokenAddress, account, chainId, decimal, orderId:string, amount:number ) => {
    const { toastSuccess, toastError } = useToast()
    const { callWithMarketGasPrice } = useCallWithMarketGasPrice()
    const { t } = useTranslation()
    const contract = useBuyVoucher(contractAddress)
    const [ pendingBuyVoucher, setPendingBuyVoucher ] = useState(false)
    const dispatch = useAppDispatch()
    const currentTime = Date.now()
    const startTime = moment(currentTime).subtract(15, 'days').valueOf()
    const handleBuyVoucher = useCallback(async () => {
    setPendingBuyVoucher(true)
    try {
        const tx = await callWithMarketGasPrice(contract, 'buyItem', [tokenAddress, amount, orderId?.toString()])
        const receipt = await tx?.wait()
        if (receipt.status) {
            // toastSuccess(
            //     t('Quy đổi thành công'),
            //     <ToastDescriptionWithTx txHash={receipt.transactionHash}/>
            // )
            dispatch(fetchFillAmount({fillAmount:0}))
            dispatch(fetchFillEmail({email:""}))
            dispatch(fetchFillPhoneNumber({phoneNumber:""}))
        } else {
            // user rejected tx or didn't go thru
            toastError(t('Đã xảy ra lỗi'), t('Vui lòng thử lại.'))
        }
        console.log('')
        return { txHash: receipt?.transactionHash}
    } catch (e) {
        toastError(t('Đã xảy ra lỗi'), t('Không đủ phí gas. Vui lòng thử lại.'))
        setPendingBuyVoucher(false)
        return { txHash: "" }
    } finally {
        setPendingBuyVoucher(false)
        // const res = await fetchPublicDataUser(contractAddress, account, tokenAddress, decimal, chainId )
        // dispatch(fetchDataUser(res))

        const resHistory = await fetchHistoryData(account, new Date(startTime).toISOString(), new Date(Date.now()).toISOString(), '', "createdAt_des", 0, PAGE_SIZE, chainId?.toString())
        dispatch(fetchHistory(resHistory))
    }
    
    }, [callWithMarketGasPrice, contract, amount, orderId, tokenAddress, toastSuccess, t, dispatch, toastError, account, startTime, chainId])
  
    return { handleBuyVoucher, pendingBuyVoucher }
}
  